angular.module('mercury.services.userinfo', []);
